import React from 'react';

interface EndpointManagementIconProps extends React.SVGProps<SVGSVGElement> {
  size?: number;
}

export const EndpointManagementIcon: React.FC<EndpointManagementIconProps> = ({
  size = 20,
  ...props
}) => {
  return (
    <svg
      fill="none"
      viewBox="0 0 20 20"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
      height={size}
      width={size}
    >
      <path
        clipRule="evenodd"
        d="M11.667 7.39583C11.6394 7.39583 11.6129 7.40681 11.5933 7.42634C11.5738 7.44588 11.5628 7.47237 11.5628 7.5V15.8333C11.5628 15.861 11.5738 15.8875 11.5933 15.907C11.6129 15.9265 11.6394 15.9375 11.667 15.9375H16.667C16.6946 15.9375 16.7211 15.9265 16.7406 15.907C16.7602 15.8875 16.7712 15.861 16.7712 15.8333V7.5C16.7712 7.47237 16.7602 7.44588 16.7406 7.42634C16.7211 7.40681 16.6946 7.39583 16.667 7.39583H11.667ZM10.5621 6.39515C10.8552 6.10212 11.2526 5.9375 11.667 5.9375H16.667C17.0814 5.9375 17.4788 6.10212 17.7718 6.39515C18.0649 6.68817 18.2295 7.0856 18.2295 7.5V15.8333C18.2295 16.2477 18.0649 16.6452 17.7718 16.9382C17.4788 17.2312 17.0814 17.3958 16.667 17.3958H11.667C11.2526 17.3958 10.8552 17.2312 10.5621 16.9382C10.2691 16.6452 10.1045 16.2477 10.1045 15.8333V7.5C10.1045 7.0856 10.2691 6.68817 10.5621 6.39515Z"
        fill="#B5BCC4"
        fillRule="evenodd"
      />
      <path
        clipRule="evenodd"
        d="M2.22815 3.06177C2.52118 2.76875 2.91861 2.60413 3.33301 2.60413H14.1663C14.5807 2.60413 14.9782 2.76875 15.2712 3.06177C15.5642 3.3548 15.7288 3.75223 15.7288 4.16663V6.66663C15.7288 7.06933 15.4024 7.39579 14.9997 7.39579C14.597 7.39579 14.2705 7.06933 14.2705 6.66663V4.16663C14.2705 4.139 14.2595 4.1125 14.24 4.09297C14.2205 4.07343 14.194 4.06246 14.1663 4.06246H3.33301C3.30538 4.06246 3.27889 4.07343 3.25935 4.09297C3.23982 4.1125 3.22884 4.139 3.22884 4.16663V14.1666C3.22884 14.1943 3.23982 14.2207 3.25935 14.2403C3.27888 14.2598 3.30538 14.2708 3.33301 14.2708H10.833C11.2357 14.2708 11.5622 14.5973 11.5622 15C11.5622 15.4027 11.2357 15.7291 10.833 15.7291H3.33301C2.91861 15.7291 2.52118 15.5645 2.22815 15.2715C1.93513 14.9785 1.77051 14.581 1.77051 14.1666V4.16663C1.77051 3.75223 1.93513 3.3548 2.22815 3.06177Z"
        fill="#B5BCC4"
        fillRule="evenodd"
      />
      <path
        clipRule="evenodd"
        d="M12.6045 7.50004C12.6045 7.09733 12.931 6.77087 13.3337 6.77087H15.0003C15.403 6.77087 15.7295 7.09733 15.7295 7.50004C15.7295 7.90275 15.403 8.22921 15.0003 8.22921H13.3337C12.931 8.22921 12.6045 7.90275 12.6045 7.50004Z"
        fill="#B5BCC4"
        fillRule="evenodd"
      />
    </svg>
  );
};
